/**
 * Labstep
 *
 * @module components/Organization/Settings/AllowMemberCreateGroup
 * @desc Organization set allow member create group
 */

import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import type React from 'react';
import type { OrganizationSettingsAllowMemberCreateGroupProps } from './types';

export const OrganizationSettingsAllowMemberCreateGroup: React.FC<
  OrganizationSettingsAllowMemberCreateGroupProps
> = ({ organization }) => (
  <div>
    <EntityActionUpdate
      entityName={organization.entityName}
      id={organization.id}
      body={{
        is_allow_member_create_group:
          !organization.is_allow_member_create_group,
      }}
      optimistic
      actionComponentProps={{
        type: 'checkbox',
        elementProps: {
          checked: organization.is_allow_member_create_group,
        },
      }}
    />
    <p>
      Enable to allow members of the organization to create new
      workspaces
    </p>
  </div>
);
